import {
  GIFT_CARDS_PAYMENT_METHODS_ENDPOINT,
  GIFT_CARDS_CHECKOUT_ENDPOINT,
} from "@config/endpoints";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";
import { PAYMENT_METHODS } from "@typings/globals";
import {
  GiftCardsCheckoutPayload,
  GiftCardsCheckoutDTO,
} from "@typings/giftCards";

import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";
import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";
import { ASYNC_ACTION_TYPES } from "@services/FetchFacade";

import { genericPendingAction } from "@app/services/GenericPendingAction";
import { asyncActionCreator } from "@app/services/AsyncActionCreator";

const action = new ReduxActionNameCreator("giftCards");

const FETCH_PAYMENT_METHODS = action.make("fetch payment methods");
const SELECT_PAYMENT_METHOD = action.make("select payment method");
const MAKE_CHECKOUT = action.make("fetch checkout");

const fetchPaymentMethods =
  () =>
  async (
    dispatch: ThunkActionDispatch,
  ): Promise<AsyncActionResult<PAYMENT_METHODS[]>> => {
    dispatch(genericPendingAction(FETCH_PAYMENT_METHODS));

    const action = await asyncActionCreator({
      action: FETCH_PAYMENT_METHODS,
      method: ASYNC_ACTION_TYPES.GET,
      url: GIFT_CARDS_PAYMENT_METHODS_ENDPOINT,
    });

    return dispatch(action);
  };

const setSelectedPaymentMethod = (paymentMethod: PAYMENT_METHODS | null) => {
  return {
    type: SELECT_PAYMENT_METHOD,
    payload: { paymentMethod },
  };
};

const makeCheckout =
  (body: GiftCardsCheckoutPayload) =>
  async (
    dispatch: ThunkActionDispatch,
  ): Promise<AsyncActionResult<GiftCardsCheckoutDTO>> => {
    dispatch(genericPendingAction(MAKE_CHECKOUT));

    const action = await asyncActionCreator({
      action: MAKE_CHECKOUT,
      method: ASYNC_ACTION_TYPES.POST,
      url: GIFT_CARDS_CHECKOUT_ENDPOINT,
      body,
    });

    return dispatch(action);
  };

export {
  FETCH_PAYMENT_METHODS,
  SELECT_PAYMENT_METHOD,
  fetchPaymentMethods,
  setSelectedPaymentMethod,
  makeCheckout,
};
